import React from 'react'
import { ToastContainer } from 'react-toastify'

export const Toaster: React.FC<unknown> = () => {
  return (
    <ToastContainer
      autoClose={10000}
      closeOnClick={false}
      position='bottom-right'
      theme='colored'
      limit={3}
    />
  )
}
